import React, { Component } from 'react';
import { connect } from 'react-redux';
import DoDisturbOnIcon from '@mui/icons-material/DoDisturbOn';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import Tree, { TreeNode } from 'rc-tree';
import EditIcon from '@mui/icons-material/Edit';
import LOOKUP from 'constants/lookup';
import { categoryListCrumb } from 'utils/breadcrumbInfo';
import { getCategoryTree, clearCategoryTree } from 'actions/EntityActions';
// Basic Components
import Grid from 'screens/components/basic/Grid';
import Button from 'screens/components/basic/Button';
// import 'rc-tree/assets/index.css';

import WithRouter from 'custom/withRouter';
import PageHeaderWithButton from 'screens/components/basic/PageHeaderWithButton';

const STYLE = `

.rc-tree li {
  margin-bottom: 6px; 
  margin-top: 4px;
}

.rc-tree-child-tree {
  display: block;
}

.node-motion {
  transition: all .5s;
  overflow-y: hidden;
}

.node-motion-enter,
.node-motion-leave-active {
  height: 0;
}
`;

const onEnterActive = (node) => {
  return { height: node.scrollHeight };
};

const motion = {
  motionName: 'node-motion',
  motionAppear: false,
  onEnterActive,
  onLeaveStart: (node) => ({ height: node.offsetHeight }),
};

const iconStyle = {
  position: "absolute",
  left: "105%",
  width: "15px",
};

class ProductCategoryList extends Component {

  static defaultProps = {
    keys: ['0-0-0']
  };

  constructor(props) {
    super(props);
    const keys = props.keys;
    this.state = {
      defaultExpandedKeys: keys,
      defaultSelectedKeys: keys,
      defaultCheckedKeys: keys,
      accessoryTree: [],
      cannabisTree: [],
      noAddSalesTree: [],
      expandAccessoryTree: ["0-0"],
      expandCannabisTree: ["0-0"],
      expandNoAddSalesTree: ["0-0"]
    };
    this.onEdit = this.onEdit.bind(this);
  }

  componentDidMount() {
    this.props.getCategoryTree();
  }

  componentWillReceiveProps(newProps) {
    if (newProps.categoryTree && ((newProps.categoryTree.cannabis && newProps.categoryTree.cannabis.length > 0) || (newProps.categoryTree.accessory && newProps.categoryTree.accessory.length > 0)) && newProps.categoryTree != this.props.categoryTree) {
      let accessArray = [];
      let cannaArray = [];
      let noAddArray = [];
      newProps.categoryTree.accessory.filter(x => x.name != "GIFTCARDS").map((item) => {
        accessArray.push({
          id: item.id.toString(),
          title: item.name
        });
      });
      newProps.categoryTree.cannabis.map((item) => {
        cannaArray.push({
          id: item.id.toString(),
          title: item.name
        })
      })
      newProps.categoryTree.accessory.filter(x => x.name == "GIFTCARDS").map((item) => {
        noAddArray.push({
          id: item.id.toString(),
          title: item.name
        });
      });
      this.setState({
        accessoryTree: accessArray,
        cannabisTree: cannaArray,
        noAddSalesTree: noAddArray
      })
    }
  }

  componentWillUnmount() {
    this.props.clearCategoryTree();
  }

  onExpand = (event, itemId) => {
    console.log(event, itemId);
    if (this.state[itemId].length > 0){
      this.setState({ ...this.state, [itemId]: []})
    }else{
      this.setState({ ...this.state, [itemId]: ["0-0"]})
    }
  };
  onSelect = (selectedKeys, info) => {
    console.log('selected', selectedKeys, info);
  };
  onCheck = (checkedKeys, info) => {
    console.log('onCheck', checkedKeys, info);
  };
  onEdit = (id) => {
    console.log("karl", id);
    this.props.navigate(`/product/category/edit/${id}`);
  };
  onDel = (e) => {
    if (!window.confirm('sure to delete?')) {
      return;
    }
    e.stopPropagation();
  };
  setTreeRef = (tree) => {
    this.tree = tree;
  };

  renderTreeNodes = (treeData) => {
    return (
      treeData.length &&
      treeData
        .sort((a, b) => a.title.toLowerCase() > b.title.toLowerCase() ? 1 : -1)
        .map((t, index) => {
          let oneCategory = (
            <span className="tree-body">{t.title}
              <i onClick={() => this.onEdit(t.id)}>
                <EditIcon id={`categoryEdit${index}`} style={iconStyle} />

              </i>
            </span>
          );
          return (
            <TreeItem label={oneCategory} itemId={`0-0-${index}`} />
          );
        })
    );
  };

  render = () => {
    let treeStyle = "myCls halfTree";
    if (this.state.noAddSalesTree.length > 0) treeStyle = "myCls thirdTree";
    const p = this.props;
    return (
      <Grid headerContent={categoryListCrumb}>
        <PageHeaderWithButton title={LOOKUP.menu.productCategory.text}>
          <Button
            type="AddButton"
            mini={true}
            className="bg-light-green"
            label="ADD NEW CATEGORY"
            onTouchTap={p.onNew} />
        </PageHeaderWithButton>

        {/* Cannabis or Vape */}
        <SimpleTreeView
          ref={this.setTreeRef}
          className={treeStyle} showLine defaultExpandAll={true}
          expandedItems={this.state.expandCannabisTree}
          onExpandedItemsChange={(e) => this.onExpand(e, "expandCannabisTree")}
          showIcon={false}
          motion={motion}

        >
          <TreeItem
            label={<span className="tree-head">{p.isVape ? "Vape" : "Cannabis"}</span>}
            itemId="0-0"
          >
            {this.renderTreeNodes(this.state.cannabisTree)}

          </TreeItem>
        </SimpleTreeView>

        {/* Accessory */}
        <SimpleTreeView
          ref={this.setTreeRef}
          className={treeStyle}
          expandedItems={this.state.expandAccessoryTree}
          showLine defaultExpandAll={true}
          onExpandedItemsChange={(e) => this.onExpand(e, "expandAccessoryTree")}
        >
          <TreeItem icon={<DoDisturbOnIcon />}  label={<span className="tree-head">Accessory</span>} itemId="0-0">
            {this.renderTreeNodes(this.state.accessoryTree)}
          </TreeItem>
        </SimpleTreeView>

        {/* No Add Sales*/}
        {this.state.noAddSalesTree.length > 0 &&
          <SimpleTreeView
            ref={this.setTreeRef}
            className={treeStyle}
            expandedItems={this.state.expandNoAddSalesTree}
            onExpandedItemsChange={(e) => this.onExpand(e, "expandNoAddSalesTree")}
          >
            <TreeItem icon={<RemoveIcon />} label={<span className="tree-head">No Add Sales</span>} itemId="0-0">
              {this.renderTreeNodes(this.state.noAddSalesTree)}
            </TreeItem>
          </SimpleTreeView>
        }
      </Grid>
    );
  }
}

function mapStatetoProps(state) {
  return {
    categoryTree: state.entity.categoryTree || [],
    isVape: state.common.applicationSettings.isVape
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getCategoryTree: () => dispatch(getCategoryTree(parseInt(localStorage.getItem('TECHPOS_SELECTED_BRANCH')))),
    clearCategoryTree: () => dispatch(clearCategoryTree())
  };
}
export default connect(mapStatetoProps, mapDispatchToProps)(WithRouter(ProductCategoryList));